<template>
  <div class="q-pa-lg" style="">
    <div>
      <el-form ref="deviceMap" :model="deviceMap":inline="true" size="small">
        <el-form-item>
          <el-input v-model="deviceMap.imei" placeholder="IMEI/设备号" />
        </el-form-item>

        <el-form-item label="区间查询:">
          <el-input v-model="deviceMap.imeiS" placeholder="开始卡号" />
        </el-form-item>
        <el-form-item>
          <el-input v-model="deviceMap.imeiE" placeholder="结束卡号" />
        </el-form-item>
        <el-form-item >
          <el-date-picker style="padding-left:3px" v-model="deviceMap.startTime" type="datetime" placeholder="选择开始时间" @change="dataSearchSt" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </el-form-item>
        <el-form-item >
          <el-date-picker v-model="deviceMap.endTime" type="datetime" placeholder="选择结束时间" @change="dataSearchEd" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain size="small" style="padding-left: 10px" @click="list(1)"  icon="el-icon-search">
            搜索
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-refresh" plain style="padding-left: 10px;" @click="resetForm()" >
            重置
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button  type="primary" plain size="small" @click.prevent="importCode"  icon="el-icon-plus">导入</el-button>
        </el-form-item>
        <el-form-item>
          <el-button  type="primary" plain size="small" @click.prevent="outDevice"  icon="el-icon-download">下载</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table :header-cell-style="{background: '#f5f7fa', color: '#606266',textAlign:'center'}"
              :data="tableData" :row-style="{height:'40px',textAlign:'center'}"
              :cell-style="{height:'5px,0',textAlign:'center'}" :max-height="maxHeight"
              style="width: 100%;margin-top: 1%" border >
      <el-table-column label="IMEI" prop="imei" width="180">
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="rechargeType" label="充值">
        <template slot-scope="scope">
          <div  class="image-wrapper">
            <img  :src="scope.row.rechargeCode" class="image" />
          </div>
        </template>
      </el-table-column>

      <el-table-column show-overflow-tooltip prop="customerType" label="客服">
        <template slot-scope="scope">
          <div  class="image-wrapper">
            <img  :src="scope.row.customerCode" class="image" />
          </div>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="createTime" label="导入时间"></el-table-column>
    </el-table>
    <pagination class="text-center" ref="pagination" v-bind:list="list" v-bind:itemCount="8"></pagination>


    <el-dialog :close-on-click-modal="false" title="导入二维码" :visible.sync="diaVisImport" class="class_dialog_hospital" width="50%">
      <span>下载模板：<a :href="importUrl">导入模板</a></span>
      <el-upload :disabled="false" ref="upload" style="text-align: center"
                 class="upload-demo" drag
                 :action="uploadUrl"
                 multiple
                 :limit=limitNum :auto-upload="false"
                 :on-change="this.$upload.onChange"
                 :before-upload="this.$upload.beforeUpload"
                 :on-exceed="this.$upload.onExcced"
                 :on-success="handleSuccess"
                 :on-error="handleError"
                 :headers="headers"
                 :file-list="fileList">
        <i class="el-icon-upload"></i>
        <div class="el-upload__tip">只能上传xls/xlsx文件</div>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>
      <div style="text-align: center">
        <el-button style="" size="small" plain type="primary" @click="uploadFile">开始上传</el-button>
        <el-button style="" size="small" plain type="info" @click="diaVisImport=false">取消上传</el-button>
      </div>

    </el-dialog>
  </div>
</template>

<script>
  import Pagination from '../../components/pagination'

  export default {
    name: 'deviceCode',
    components: {
      Pagination,
    },
    mounted() {
      let _this = this
      _this.roleId =_this.$loginUser.roleId
      _this.headers={
        token: sessionStorage.getItem("sys-token"),
        userId: sessionStorage.getItem("loginUser")!==null?JSON.parse(sessionStorage.getItem("loginUser")).id:''
      }
    },
    data() {
      return {
        show:false,
        headers: '',
        roleId: '',
        devicejs: require('../../api/device'),
        limit:1,
        imei:'',
        deviceMap:{
          imei:'',
          imeiS:'',
          imeiE:'',
          startTime:'',
          endTime:'',
          pageNo:1,
          pageSize:10,
        },
        diaVisImport: false,
        fileList: [],
        maxHeight: 500,
        tableData: [],
        templateCode: [],
        aollpackey: Math.random(100)*100,
        limitNum: 1,
        importUrl: this.$modelUrl+'/导入二维码.xlsx',
        uploadUrl: process.env.VUE_APP_SERVER + '/manager/deviceCode/uploadExcel',
      }
    },
    methods: {
      dataSearchSt(data) {
        this.deviceMap.startTime=data
      },
      dataSearchEd(data) {
        this.deviceMap.endTime=data
      },
      importCode() {
        this.$confirm('当前要导入的这批设备是否已经上传过?', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        })
                .then(() => {
                  this.diaVisImport = false
                })
                .catch(() => {
                  this.diaVisImport = true
                })
      },
      async outDevice(){
        let _this = this
        if (_this.$check.checkIsNull(_this.deviceMap.imei)
                && _this.$check.checkIsNull(_this.deviceMap.imeiS)&& _this.$check.checkIsNull(_this.deviceMap.imeiE)
                && _this.$check.checkIsNull(_this.deviceMap.startTime)&& _this.$check.checkIsNull(_this.deviceMap.endTime)) {
          _this.$alert('请先选择筛选条件！')
          return false
        }

        _this.$confirm('由于导出数据需要一定时间，请确定是否需要下载。', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.deviceMap.pageNo =1
          this.deviceMap.pageSize = _this.$refs.pagination.size
          _this.devicejs.exportExcelCode( this.deviceMap)
                  .then(res => {
                    _this.$alert('已操作导出，请稍后到功能模块：业务管理中的执行任务管理下载查看！')
                  })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消！'
          })
        })
      },
      resetForm() {
        this.deviceMap =this.$options.data().deviceMap
      },
      list(page) {
        let _this = this
        _this.maxHeight = _this.$listenHeight.getBodyHeight()

        _this.tableData = []
        _this.deviceMap.pageNo=page
        _this.deviceMap.pageSize=_this.$refs.pagination.size
        _this.devicejs.queryDeviceCodeList(_this.deviceMap).then(res => {
          if (res.data.code === '0') {
            _this.tableData = res.data.data.rows
            _this.$refs.pagination.render(page, res.data.data.total)
          } else {
            this.$message.warning(res.msg)
          }
        }).catch(err=> {
          this.$message.warning(res.msg)
        })
      },

      // 文件上传成功时的钩子
      handleSuccess(res, file, fileList) {
        let _this = this
        clearInterval(_this.timer)
        if (res.code === '0') {
          this.$alert(res.data)
          this.diaVisImport=false
        } else {
          this.$alert(res.msg)
          this.$refs.upload.clearFiles()
        }
      },
      // 文件上传失败时的钩子
      handleError(err, file, fileList) {
        let _this = this
        clearInterval(_this.timer)
        this.alert.error('文件上传失败')

        this.$refs.upload.clearFiles()
      },
      uploadFile() {
        this.$refs.upload.submit()
      },
    }
  }
</script>

<style lang="css" >
  .el-tooltip__popper {
    max-width: 70%;
  }
</style>
<style scoped>
  .image {
    width: 50px; /* 原始宽度 */
    height: 50px; /* 原始高度 */
  }

  .image-wrapper:hover .image {
    width: auto; /* 原始宽度 */
    height: auto; /* 原始高度 */
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 9999;
  }
  .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
  /*滚动条样式*/
  /deep/ ::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 8px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 8px;
  }
  /deep/ ::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 8px;
    box-shadow: inset 5px 0px 5px #f0f0f0;
    background: #d9d9d9;
  }
  /deep/ ::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px #f0f0f0;
    border-radius: 8px;
    background: #ffffff;
  }

  /deep/.el-table .el-table__cell {
    padding: 9px;
  }
  /deep/thead.has-gutter {
    height: 40px;
  }
</style>
<style scoped>
  .box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  /deep/ .el-main {
    text-align: left;
    padding: 20px !important;
    overflow: hidden !important;
  }
  .active{
    border: 1px solid #66b1ff;
    width: 56px;
    height: 28px;
    line-height: 1.5rem;
    border-radius: 4px;
    text-align: center;
    background-color: #66b1ff;
    color: #fff;
    margin-right: 10px;
  }
  .btn{
    border: 1px solid #23241f;
    width: 56px;
    height: 28px;
    line-height: 1.5rem;
    border-radius: 4px;
    text-align: center;
    background-color: white;
    color: black;
    margin-right: 10px;

  }
  /* --------------------------弹窗样式------------------------------ */
  /*标题样式*/
  /deep/.class_dialog_hospital .el-dialog__title {
    font-size: 15px;
    margin-left: 15px;
  }

  /*头区样式*/
  /deep/.class_dialog_hospital .el-dialog__header {
    height: 50px;
    background: #e6e6e6;
    padding: 15px 0 4px 10px;
    border-top-left-radius: 9px;
    border-top-right-radius: 9px;
  }

  /*头区退出按钮样式*/
  /deep/.class_dialog_hospital .el-dialog__headerbtn {
    top: 14px;
    right: 20px;
    font-size: 16px;
  }

  /*对话框区*/
  /deep/.class_dialog_hospital .el-dialog {
    border: 1px solid #dcdfe6;
    box-shadow: 0 0 4px #e6e6e6;
    border-radius: 9px;
    padding: 0;
  }

  /*内容区*/
  /deep/.class_dialog_hospital .el-dialog__body {
    padding: 20px;
  }
  /deep/.el-input.is-disabled .el-input__inner {
    color: #333;
    font-weight: 700;
  }

  /*脚区*/
  /deep/.class_dialog_hospital .el-dialog__footer {
    border-top: 2px solid #e8eaec;
    padding: 16px;
  }
</style>